import React from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "../utils/protectedRoutes";
import AdminDashboard from "../admin/pages/adminDashboard";
import AdminSidebar from "../admin/components/adminSidebar";
import AdminUser from "../admin/pages/user/adminUser";
import NotFound from "../pages/notFound/notFound";
import UserDetail from "../admin/pages/user/userDetail/userDetail";
import Stats from "../admin/pages/stats/stats";
import Issues from "../admin/pages/issues/issues";
import { UserProvider } from "../admin/utils/userProvider";
import AddUser from "../admin/pages/user/addUser/addUser";

const AdminRoutes = () => {
  return (
      <div style={{ display: "flex", flex: 1 }}>
        <AdminSidebar />
        <div style={{ flex: 1 }}>
          <UserProvider>
            <Routes>
              <Route path="/dashboard" element={<ProtectedRoute element={<AdminDashboard />} />} />
              <Route path="/user" element={<ProtectedRoute element={<AdminUser />} />} />
              <Route path="/user/:id" element={<ProtectedRoute element={<UserDetail />} />} />
              <Route path="/user/new" element={<ProtectedRoute element={<AddUser />} />} />
              <Route path="/stats" element={<ProtectedRoute element={<Stats />} />} />
              <Route path="/issues" element={<ProtectedRoute element={<Issues />} />} />
              
              <Route path="*" element={<NotFound />} />
            </Routes>
          </UserProvider>
        </div>
      </div>
  );
};

export default AdminRoutes;